/**
 * SkillDelivery Platform
 *
 * Copyright © 2026 SKD RATWANI Technology & Software Solutions Pvt Ltd
 * All Rights Reserved.
 *
 * PROPRIETARY AND CONFIDENTIAL
 */

import React from 'react';

// Risk bands: green ≤20, yellow 21-50, orange 51-80, red ≥81.
// Returns "—" (gray) when riskScore is null/undefined/non-numeric so the
// UI degrades gracefully if V2 hasn't computed SEAL yet.
function bandFor(score) {
  if (score === null || score === undefined || Number.isNaN(Number(score))) {
    return { bg: '#f1f5f9', fg: '#64748b', label: '—', dot: '#94a3b8' };
  }
  const n = Number(score);
  if (n <= 20) return { bg: '#dcfce7', fg: '#15803d', label: 'Low',      dot: '#16a34a' };
  if (n <= 50) return { bg: '#fef9c3', fg: '#a16207', label: 'Moderate', dot: '#eab308' };
  if (n <= 80) return { bg: '#ffedd5', fg: '#c2410c', label: 'High',     dot: '#f97316' };
  return        { bg: '#fee2e2', fg: '#b91c1c', label: 'Critical', dot: '#dc2626' };
}

export default function SealRiskBadge({ riskScore }) {
  const b = bandFor(riskScore);
  const numeric = Number(riskScore);
  const showScore = !Number.isNaN(numeric) && riskScore !== null && riskScore !== undefined;

  return (
    <span style={{
      display: 'inline-flex',
      alignItems: 'center',
      gap: '6px',
      fontSize: '11px',
      fontWeight: 600,
      padding: '2px 8px',
      borderRadius: '12px',
      background: b.bg,
      color: b.fg,
      lineHeight: 1.4,
    }}>
      <span style={{
        width: '8px',
        height: '8px',
        borderRadius: '50%',
        background: b.dot,
      }} />
      {b.label}
      {showScore && <span style={{ opacity: 0.7 }}>· {Math.round(numeric)}</span>}
    </span>
  );
}
